var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { withTheme } from 'emotion-theming';
/**
 * This is mostly a full copy of react-media, with a fix for "two-pass" render issue:
 * https://github.com/ReactTraining/react-media/pull/96
 *
 * I also removed everything that is unneccesary in our application, which makes this lib
 * a little bit smaller
 *
 * At some point we all will use React hooks and this piece of code could be thrown away
 *
 * MIT License
 *
 * Copyright (c) 2016-2017 React Training
 *
 * https://github.com/ReactTraining/react-media
 */
var Media = /** @class */ (function (_super) {
    __extends(Media, _super);
    function Media(props) {
        var _this = _super.call(this, props) || this;
        _this.queries = null;
        _this.updateMatches = _this.updateMatches.bind(_this);
        // This logic allows to avoid "two-pass render" in some
        // cases where defaultMatches are not used
        if (typeof window !== 'object') {
            // We are on the server, let's set some defaults
            _this.state = {
                matches: props.defaultMatches ||
                    Object.keys(_this.props.queries).reduce(function (acc, key) {
                        var _a;
                        return (__assign(__assign({}, acc), (_a = {}, _a[key] = true, _a)));
                    }, {}),
            };
        }
        else {
            // Init matchMedia listeners on client ...
            _this.initialize();
            // ... and set them to state right away
            _this.state = {
                matches: _this.props.defaultMatches || _this.getMatches(),
            };
        }
        return _this;
    }
    Media.prototype.getMatches = function () {
        return this.queries.reduce(function (acc, _a) {
            var _b;
            var name = _a.name, mqList = _a.mqList;
            return (__assign(__assign({}, acc), (_b = {}, _b[name] = mqList.matches, _b)));
        }, {});
    };
    Media.prototype.updateMatches = function () {
        this.setState({ matches: this.getMatches() });
    };
    Media.prototype.initialize = function () {
        var _this = this;
        var queries = this.props.queries;
        this.queries = Object.keys(queries).map(function (name) {
            var mqList = window.matchMedia(queries[name]);
            mqList.addListener(_this.updateMatches);
            return { name: name, mqList: mqList };
        });
    };
    Media.prototype.componentDidMount = function () {
        // If props.defaultMatches has been set, ensure we trigger a two-pass render.
        // This is useful for SSR with mismatching defaultMatches vs actual matches from window.matchMedia
        // Details: https://github.com/ReactTraining/react-media/issues/81
        if (this.props.defaultMatches !== undefined) {
            this.updateMatches();
        }
    };
    Media.prototype.componentWillUnmount = function () {
        var _this = this;
        this.queries.forEach(function (_a) {
            var mqList = _a.mqList;
            return mqList.removeListener(_this.updateMatches);
        });
        this.queries = null;
    };
    Media.prototype.render = function () {
        return this.props.children(this.state.matches);
    };
    return Media;
}(React.Component));
/**
 * Uses Media component to provide global media queries from
 * the theme object without the need to specify them
 * manually
 */
export var ThemedMedia = withTheme(function (_a) {
    var theme = _a.theme, children = _a.children, defaultMatches = _a.defaultMatches;
    /**
     * WARNING: if the theme.breakpoints changes
     * please update this code
     */
    var _b = __read(theme.breakpoints, 3), tablet = _b[0], desktop = _b[1], large_desktop = _b[2]; // tslint:disable-line variable-name
    var queries = {
        tablet: "(min-width: " + tablet + ")",
        desktop: "(min-width: " + desktop + ")",
        large_desktop: "(min-width: " + large_desktop + ")",
    };
    // Provide merged defaultMatches if they are
    // passed, but ONLY if they are passed. This
    // allows to avoid two-pass render if defaultMatches
    // are not provided
    //
    // Always merge provided with default, that
    // allows for less manual work when using defaultMatches
    var matches = defaultMatches
        ? __assign({ tablet: true, desktop: true, large_desktop: true }, defaultMatches) : undefined;
    return (React.createElement(Media, { queries: queries, defaultMatches: matches }, children));
});
export default Media;
